import script from "./FileTypeItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileTypeItem.vue?vue&type=script&setup=true&lang=ts"

import "./FileTypeItem.vue?vue&type=style&index=0&id=da74d798&scoped=true&lang=css"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da74d798"]])

export default __exports__